import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ChangeDetectionStrategy
} from "@angular/core";

import { Environment } from "src/components/shared-components/class/general-classes/environment";

@Component({
    selector: "app-widget-counter-band",
    templateUrl: "./widget-counter-band.component.html",
    styleUrls: [
        "./widget-counter-band.component.scss",
        "../../styles/shared-global.scss",
    ],
    changeDetection: ChangeDetectionStrategy.Eager
})

/**
 * Counter band entry componet
 */
export class WidgetCounterBandComponent {
  public listEnvironments: Array<Environment> = new Array();

  @Input() title: string = "";
  @Input() subtitle: string = "";
  @Input() title_value: string = "";
  @Input() value: string = "";
}
